import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {SafeStyle} from '@angular/platform-browser';

@Component({
  selector: 'awair-draggable-device-marker',
  templateUrl: './draggable-device-marker.component.html',
  styleUrls: ['./draggable-device-marker.component.scss']
})

export class DraggableDeviceMarkerComponent implements OnInit {

  @HostBinding('style.top') hostTop: string | SafeStyle = '0px';
  @HostBinding('style.left') hostLeft: string | SafeStyle = '0px';

  @Input() name: string;
  @Input() color: string = '#64C2E6';
  @Input() deviceUuid: string;
  @Output() remove: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
  }

  onRemove(): void {
    this.remove.emit(this.deviceUuid);
  }
}
